import { render, staticRenderFns } from "./NoticeTemplate.vue?vue&type=template&id=8624747e&scoped=true"
import script from "./NoticeTemplate.vue?vue&type=script&lang=js"
export * from "./NoticeTemplate.vue?vue&type=script&lang=js"
import style0 from "./NoticeTemplate.vue?vue&type=style&index=0&id=8624747e&prod&lang=less&scoped=true"
import style1 from "./NoticeTemplate.vue?vue&type=style&index=1&id=8624747e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8624747e",
  null
  
)

export default component.exports